<template>
  <div
    v-if="sight.description"
    v-view-tracker="analyticsParams"
    class="subtitle obs-el"
    data-attr="info"
  >
    {{ sight.description }}
  </div>
</template>

<script setup lang="ts">
  import { useViewTracker } from '@/services/analytics';
  import { type CityTagsAdvanced } from '@/shared/models/types';
  import { useSightAnalyticsParams } from '@/shared/utils/analytics';

  const props = defineProps<{
    sight: CityTagsAdvanced;
  }>();

  const analyticsParams = useSightAnalyticsParams(() => props.sight);
  const vViewTracker = useViewTracker('attractions:sights:sight-popup:description.view');
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .title {
    color: var(--alias-color-link-darked);

    @include legacy-typography.base-700-500-extra;
  }

  .subtitle {
    margin-top: var(--alias-space-20);

    @include legacy-typography.base-400-400-regular;
  }
</style>
